import React from "react";
import { View, Text } from "react-native";

import { useAppTheme } from '../../../design-system/ThemeProvider';
import { createAuthStyles } from "../AuthScreen.styles";

const Footer: React.FC = () => {
  const { colors } = useAppTheme();
  const styles = createAuthStyles(colors);
  return (
    <View style={styles.footer}>
      <Text style={styles.footerText}>
        By signing in, you agree to our Terms & Privacy Policy.
      </Text>
    </View>
  );
};

export default Footer;
